/* Tax rates are configured in Shopify. This code selects actual product variants. */
(() => {
  'use strict';
  function matchVariant(data, purpose, index) {
    const options = data.baseOptions[index];
    if (!options || !['own', 'employer'].includes(purpose)) return null;
    const matches = data[purpose].variants.filter(v => JSON.stringify(v.options) === JSON.stringify(options));
    return matches.length === 1 ? matches[0] : null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {matchVariant};
  if (typeof document === 'undefined') return;
  function init(root) {
    if (root.dataset.twReady) return;
    const payload = root.querySelector('[data-tw-vat-data]');
    if (!payload) return;
    root.dataset.twReady = 'true';
    const data = JSON.parse(payload.textContent);
    const form = root.querySelector('form');
    const purpose = form.elements.purpose, size = form.elements.size;
    const check = form.elements.declaration, quantity = form.elements.quantity;
    const amount = root.querySelector('.tw-vat-amount'), status = root.querySelector('.tw-vat-status');
    const button = form.querySelector('button');
    let busy = false;
    const selected = () => size.value === '' ? null : matchVariant(data, purpose.value, Number(size.value));
    function update() {
      const own = purpose.value === 'own';
      root.querySelector('.tw-vat-declaration').hidden = !own;
      check.required = own;
      const variant = selected();
      amount.textContent = variant ? variant.price + (own ? ' · 0% UK VAT' : ' · includes 20% UK VAT') : 'Choose purpose and size to see your price.';
      status.textContent = !purpose.value || size.value === '' ? '' : !variant ? 'This option is not configured for that purchase purpose. Please contact Toolwear.' : !variant.available ? 'This size is currently unavailable.' : '';
      button.disabled = busy || !variant || !variant.available || (own && !check.checked);
    }
    form.addEventListener('change', update);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      update();
      const variant = selected();
      if (button.disabled || !form.reportValidity() || !variant) return;
      const count = Number(quantity.value);
      if (!Number.isInteger(count) || count < 1 || count > 99) return;
      busy = true; update(); button.textContent = 'Adding…';
      try {
        const own = purpose.value === 'own';
        const response = await fetch(data.addUrl, {
          method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: variant.id, quantity: count, properties: {
            'Purchase purpose': own ? 'Own use at work' : 'Employer buying for employees',
            'VAT declaration': own ? 'I confirm I am buying these boots for my own use at work, not to supply to employees.' : 'Purchased for employees; standard UK VAT treatment',
            '_tw_vat_selector': '1'
          }}]})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to add this size. Please try again.');
        window.location.assign(data.cartUrl);
      } catch (error) {
        busy = false; update(); button.textContent = 'Add to basket';
        status.textContent = error.message || 'Unable to add to basket. Please try again.';
      }
    });
    update();
  }
  function scan() {document.querySelectorAll('[data-tw-vat]').forEach(init);}
  scan(); document.addEventListener('shopify:section:load', scan);
  new MutationObserver(scan).observe(document.documentElement, {childList:true, subtree:true});
})();
